import React from "react";
import { Eye, Edit3 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/context/LangContext";

export const SellerPreviewModal = ({ open, onOpenChange, title, children, onEdit, testid = "seller-preview-modal" }) => {
  const { lang } = useLang();
  const goEdit = onEdit || (() => onOpenChange(false));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-5xl w-[95vw] p-0 gap-0 brutal border-black bg-canales-cream max-h-[92vh] overflow-hidden flex flex-col"
        data-testid={testid}
      >
        <div className="flex items-center gap-2 px-4 py-3 pr-12 bg-canales-yellow border-b-4 border-black shrink-0">
          <Eye className="w-4 h-4 shrink-0" />
          <DialogTitle className="font-display font-black uppercase tracking-widest text-sm">
            {title || (lang === "es" ? "Vista previa — así lo ve el vendedor" : "Preview — how the seller sees it")}
          </DialogTitle>
          <button
            onClick={goEdit}
            data-testid="seller-preview-edit"
            className="ml-auto brutal-sm bg-white px-3 py-1.5 text-xs font-display font-black flex items-center gap-1 hover:bg-canales-cream"
          >
            <Edit3 className="w-3.5 h-3.5" /> {lang === "es" ? "Editar" : "Edit"}
          </button>
        </div>
        <DialogDescription className="sr-only">
          {lang === "es" ? "Vista previa del contenido tal como lo verá el vendedor." : "Content preview as the seller will see it."}
        </DialogDescription>
        <div className="overflow-y-auto flex-1" data-testid="seller-preview-body">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};
